import { env } from '@/app/config/env'
import { request } from '@/shared/api/http-client'
import { modelCatalogResponseSchema } from './model-catalog-contract'
import { mapModelCatalogResponse } from './model-catalog-mapper'
import { persistModelCatalog } from './model-catalog-storage'
import { builtInModels } from '../model/built-in-models'
import type { ModelCatalogSnapshot } from '../model/ai-model'

export async function getModelCatalog(signal?: AbortSignal): Promise<ModelCatalogSnapshot> {
  if (env.enableMock) {
    return { models: builtInModels, version: 'mock-1', fetchedAt: Date.now(), source: 'mock' }
  }

  const response = await request(env.modelCatalogEndpoint, { method: 'GET', ...(signal ? { signal } : {}), schema: modelCatalogResponseSchema })
  const snapshot = mapModelCatalogResponse(response)
  persistModelCatalog(snapshot)
  return snapshot
}
